import { useAppSelector } from 'app/store'
import { useAppModeContext } from 'app/contexts/app-mode/app-mode.context'

export default function useIsLogoutButtonVisible() {
  const { isTeacher } = useAppSelector((state) => state.userData.kcInfo)
  const { isThin } = useAppModeContext()

  const isLogoutButtonVisible = !isThin && isTeacher

  return {
    isLogoutButtonVisible,
  }
}
